export const API_BASE_URL = "https://api-admin-tf3qrxxsxq-uc.a.run.app";

export function makeUrl(target) {
  return `${API_BASE_URL}/api${target}`;
}
